import { useIntl } from "react-intl";

const PageVersioning = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "ConfluencePricingPage.features.pageVersioning.header",
            defaultMessage: "Page versioning"
        }),
        content: intl.formatMessage({
            id: "ConfluencePricingPage.features.pageVersioning.content",
            defaultMessage:
                "Track and view the history of changes to each page, compare different versions, and roll back to a previous version if needed."
        }),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.features.pageVersioning.altText",
            defaultMessage: "Example of page versions"
        }),
        caption: intl.formatMessage({
            id: "ConfluencePricingPage.features.pageVersioning.caption",
            defaultMessage: "Here’s what page versions look like in Confluence."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/CE_-_Page_versioning__@1x.webp"
                alt={messages.altText}
                height={350}
                loading="lazy"
            />
            <p>{messages.caption}</p>
        </>
    );
};

export default PageVersioning;
